<template>
  <WidgetPanel>
    <template #header>
      <h3 class="widget-headline">
        Aktivitäten
      </h3>
    </template>
    <template #default>
      <section v-if="empty">
        <div class="px-4 py-5 sm:px-6">
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Bisher noch leer. Starte z.B. als Nächstes ein Experiment.
          </p>
        </div>
      </section>
      <section v-else="empty" class="lg:col-span-1 lg:col-start-3">
        <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">
          <div class="flow-root">
            <ul role="list" class="-mb-8">
              <ActivityWidgetItem v-for="(e, i) in results" :key="e.id" :event="e" :last="ending(i)" as="li" />
            </ul>
          </div>
        </div>
      </section>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({experiment: Object});

const parent = computed(() => props.experiment.id);
const target = computed(() => '/api/experiments/' + parent.value + '/events');
const ending = (index) => index >= results.value.length-1;

const action = useFetchResources(target);

const { results, fetch, fetching, empty } = action;

const onChange = watch(parent, fetch);
const onMount = onMounted(fetch);
</script>

